import { BookOpen, Clapperboard, Brain, Sparkles, FileText, GraduationCap, LayoutGrid, ListChecks, MessageSquareText, Shield, UserRound } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface LearnLink {
  name: string;
  href: string;
  description: string;
  icon: LucideIcon;
}

/** Single source of truth for Learn destinations (nav, mobile, palette, hub). */
export const LEARN_LINKS: LearnLink[] = [
  { name: "Learning Hub", href: "/learn", description: "Start here — every way to learn on GenieBot", icon: LayoutGrid },
  { name: "Practice", href: "/learn/practice", description: "Real-world scenarios, projects and the capstone", icon: ListChecks },
  { name: "AI Video Lab", href: "/ai-video-lab", description: "Free AI Kenny trainings on AI video prompting and Digital Twins", icon: Clapperboard },
  { name: "Courses", href: "/courses", description: "Short, practical AI courses", icon: GraduationCap },
  { name: "Thinking Academy", href: "/thinking-academy", description: "Puzzles and challenges that sharpen thinking", icon: Brain },
  { name: "Prompt Training", href: "/prompt-training", description: "Practice giving AI clear instructions", icon: MessageSquareText },
  { name: "Prompt Coach", href: "/prompt-conversationist", description: "A guided chat that teaches you to write better prompts", icon: Sparkles },
  { name: "AI Safety Guide", href: "/security-guide", description: "Use AI safely and protect your data", icon: Shield },
  { name: "Security Checklist", href: "/security-checklist", description: "A quick checklist for safer AI use", icon: ListChecks },
  { name: "Training Resources", href: "/training", description: "Guides and downloadable materials", icon: FileText },
  { name: "Meet AI Kenny", href: "/courses/instructor", description: "Your instructor and guide", icon: UserRound },
  { name: "Learning Articles", href: "/blogs", description: "Plain-English articles on AI", icon: BookOpen },
];

export type LearnTrackId = "ai-safety" | "prompting" | "cybersecurity" | "ai-fluency";

/** Future track paths — breadcrumb labels are registered now for Stage 2. */
export const LEARN_TRACK_LABELS: Record<LearnTrackId, string> = {
  "ai-safety": "AI Safety",
  prompting: "Prompting",
  cybersecurity: "Cybersecurity",
  "ai-fluency": "AI Fluency",
};
